var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React from 'react';
import Icon from '../Icon';
import Text from '../Text';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    alignIcon: {
        display: 'inline-flex',
        marginRight: Tokens.spacingXxSmall,
        verticalAlign: 'middle'
    },
    textPadding: {
        display: 'inline',
        paddingLeft: Tokens.spacingXSmall
    }
});
const IconText = (props) => {
    const { classes, className, text } = props, rest = __rest(props, ["classes", "className", "text"]);
    let classText = classes.textPadding;
    if (className) {
        classText = classnames(classText, className);
    }
    let iconText;
    if (text) {
        iconText = (React.createElement(Text, Object.assign({ className: classText }, rest), text));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.alignIcon },
            React.createElement(Icon, Object.assign({ className: className }, rest))),
        iconText));
};
export default withStyles(styles)(IconText);
